import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { warehouseService } from '../api/warehouse.service';
import { WarehouseColumns } from '../warehouses';

export const Warehouses = () => {
  const translationPrefix = 'pages.warehouse.list';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = WarehouseColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={warehouseService} refresh={datagridRefresh} />
    </TenantPage>
  );
};
